import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';
import type { Props } from './SeriesChart';

const Chart = lazy(() =>
  import('./SeriesChart').then(({ SeriesChart }) => ({
    default: SeriesChart,
  })),
);

export function SeriesChartLazy<T extends string>(props: Props<T>) {
  return (
    <Suspense fallback={<Loader active />}>
      <Chart {...props} />
    </Suspense>
  );
}
